export default [
  {
    path: '/ticket_checking',
    name: 'TicketCheckingRecord',
    component: () =>
      import(/* webpackChunkName: "ticket" */ './TicketCheckingRecord.vue')
  },
  {
    path: '/ticket_sell',
    name: 'TicketSellRecord',
    component: () =>
      import(/* webpackChunkName: "ticket" */ './TicketSellRecord.vue')
  }
]
